import { AxiosResponse } from 'axios';

import apiClient from '../client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { LinkCompanyContactDto } from 'interfaces/companies/contact';
import { ContactCompanyDto } from 'interfaces/contact';

interface ContactCompanyService {
  get(contactId: string): Promise<ContactCompanyDto[]>;
  link(contactId: string, companyId: string, postData: LinkCompanyContactDto): Promise<void>;
  unlink(contactId: string, companyId: string): Promise<void>;
}

const endpoints = {
  get: (contactId: string) => `/contacts/${contactId}/companies`,
  link: (contactId: string, companyId: string) => `/contacts/${contactId}/companies/${companyId}`,
  unlink: (contactId: string, companyId: string) => `/contacts/${contactId}/companies/${companyId}`,
};

export const contactCompanyService: ContactCompanyService = {
  get: async (contactId: string): Promise<ContactCompanyDto[]> => {
    const response: AxiosResponse<ApiResponseDto<ContactCompanyDto[]>> = await apiClient.get(endpoints.get(contactId));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  link: async (contactId: string, companyId: string, postData: LinkCompanyContactDto): Promise<void> => {
    const response: AxiosResponse<ApiResponseDto<void>> = await apiClient.put(endpoints.link(contactId, companyId), postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }
  },
  unlink: async (contactId: string, companyId: string): Promise<void> => {
    const response: AxiosResponse<ApiResponseDto<void>> = await apiClient.delete(endpoints.unlink(contactId, companyId));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }
  },
};
